import styles from './TextBox.module.css';

interface InputLabelProps {
    id?: string;
    text: string;
    required?: boolean;
}

export const InputLabel = (props: InputLabelProps) => {
    const {id, text, required} = props;

    return (
        <label htmlFor={id} className={styles['form-label']}>
            {text}
            {required && <span className={styles['required']}>Required</span>}
        </label>
    );
};

interface LegendProps {
    text: string;
    required?: boolean;
}

export const Legend = (props: LegendProps) => {
    const {text, required} = props;

    return (
        <legend className={styles['form-legend']}>
            {text}
            {required && <span className={styles['required']}>Required</span>}
        </legend>
    );
};

export interface TextBoxProps {
    numberLine?: number;
    placeholder?: string;
    maxLength?: number;
    invalid?: boolean;
    id?: string;
    type?: string;
    value?: string;
    disabled?: boolean;
    min?: number;
    max?: number;
    required?: boolean;
    pattern?: any;
    ariaLabel?: string;
    name?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export const TextBox = (props: TextBoxProps) => {
    const {
        numberLine,
        placeholder,
        maxLength,
        invalid,
        id,
        type,
        value,
        disabled,
        min,
        max,
        required,
        pattern,
        ariaLabel,
        name,
        onChange,
    } = props;

    return numberLine && numberLine >= 2 ? (
        <textarea
            id={id}
            rows={numberLine}
            placeholder={placeholder}
            maxLength={maxLength}
            aria-invalid={invalid}
            disabled={disabled}
            required={required}
            aria-label={ariaLabel}
            className={styles.textbox}
            value={value}
            name={name}
            onChange={onChange}></textarea>
    ) : (
        <input
            className={styles.textbox}
            id={id}
            placeholder={placeholder}
            maxLength={maxLength}
            type={type}
            aria-invalid={invalid}
            disabled={disabled}
            min={min}
            max={max}
            required={required}
            pattern={pattern}
            aria-label={ariaLabel}
            value={value}
            name={name}
            onChange={onChange}
        />
    );
};
